import * as React from 'react';

const Bg24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#D62612", d: "M3 14v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#00966E", d: "M21 10H3v4h18z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M5 6a2 2 0 0 0-2 2v2h18V8a2 2 0 0 0-2-2z" }));
Bg24.Size = 24;
Bg24.Title = "Bg";

export { Bg24 as default };
